// src/components/ApplicationsTable.tsx
import React from 'react';
import {
  Box,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Typography,
  TableContainer,
  LinearProgress,
  Card,
  CardContent
} from '@mui/material';

interface ApplicationData {
  name: string;
  users: number;
  importance: number;
  features: number;
  usability: number;
  dataQuality: number;
}
type ApplicationsTableProps = {
  data: ApplicationData[];
  names:string;
};
const getColor = (value: number): string => {
  // Define color ranges here
  if (value < 60) return '#8B4513'; // darkbrown
  if (value < 80) return '#DAA520'; // gold
  return '#228B22'; // green
};

const renderProgressBar = (value: number) => (
  <Box sx={{position: 'relative', display: 'flex', alignItems: 'center'}}>
    <Box sx={{width: '100%', mr: 1, borderRadius: 20, overflow: 'hidden'}}>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          textAlign: 'center',
          zIndex: 1
        }}>
        <Typography
          variant="body2"
          color="#fff"
          align="left"
          paddingLeft="5px">{`${value}%`}</Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          height: 20,
          '& .MuiLinearProgress-bar': {
            backgroundColor: getColor(value)
          }
        }}
      />
    </Box>
  </Box>
);
const ApplicationsTable: React.FC<ApplicationsTableProps> = ({ data ,names}) => (
<Card>
  <CardContent>
  <Typography variant="h6" component="div" style={{display:'flex',alignItems:'center',flexWrap:'wrap',paddingBottom:'21px'}}>
        {names}
        {/* <InfoIcon color="action" style={{paddingLeft:'5px',color:'#4040ab'}}/> */}
      </Typography>
      <TableContainer >
        <Table aria-label="applications table">
          <TableHead>
            <TableRow>
              <TableCell>Application</TableCell>
              <TableCell align="left">Users</TableCell>
              <TableCell align="left">Importance</TableCell>
              <TableCell align="left">Features</TableCell>
              <TableCell align="left">Usability</TableCell>
              <TableCell align="left" style={{whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis'}}>Data Quality</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row: ApplicationData) => (
              <TableRow key={row.name}>
                <TableCell component="th" scope="row" style={{padding:'12.3px',whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis'}}>
                  {row.name}
                </TableCell>
                <TableCell align="left" style={{padding:'12.3px'}}>{row.users}</TableCell>
                <TableCell align="left" style={{padding:'12.3px'}}>
                  {renderProgressBar(row.importance)}
                </TableCell>
                <TableCell align="left" style={{padding:'12.3px'}}>
                  {renderProgressBar(row.features)}
                </TableCell>
                <TableCell align="left" style={{padding:'12.3px'}}>
                  {renderProgressBar(row.usability)}
                </TableCell>
                <TableCell align="left" style={{padding:'12.3px'}}>
                  {renderProgressBar(row.dataQuality)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </CardContent>
    </Card>
  );

export default ApplicationsTable;
